module.exports = __webpack_public_path__ + "static/media/tz_15.afd79d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tz_15.png
// module id = 94
// module chunks = 5 6 9 10 11 12